
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class SwipeAnimation extends Vue {
    @Prop({ default: false }) display: boolean;
    @Prop({ default: '' }) className: string;

    @Watch('display', { immediate: true })
    public onDisplay(value: boolean): void {
        this.$nextTick(() => {
            if (value) {
                const swipeAnimationContainer = this.$refs.swipeAnimationContainer as HTMLElement;
                if (swipeAnimationContainer) {
                    (swipeAnimationContainer.previousElementSibling as HTMLElement).style.display = 'none';
                }
            }
        });
    }
}
